import React from 'react'
import type { SaveCancelButtonsProps } from '@ztechapps/webui.button'
import { FormSaveButton } from '@ztechapps/webui.form'
import type { QuickAddTaskComponent } from '@ztechapps/task.webui'
import { QuickAddTask } from '@ztechapps/task.webui'

const TaskFormSave = (_props: SaveCancelButtonsProps) => <FormSaveButton text="Create" />
const components = {
  saveCancelButtons: TaskFormSave,
} as QuickAddTaskComponent

export const AddTask = ({ onCloseMenu }: { onCloseMenu: () => void }) => {
  return <QuickAddTask components={components} onCloseMenu={onCloseMenu} />
}
